import { useCallback } from 'react';

import { useApolloClient } from '@apollo/client/react';

import { LogSessionContent, SESSION_CONTENT, SESSION_CONTENT_BOUNDED } from '@/hooks/useLogs';
import { computeSessionBoundDate } from '@/util/dateUtils';

export const usePrefetchSessionContent = () => {
  const client = useApolloClient();

  const prefetch = useCallback(
    (sessionId: string, startTime?: string) => {
      const startDate = startTime ? computeSessionBoundDate(startTime) : undefined;
      client
        .query<LogSessionContent>({
          query: startDate ? SESSION_CONTENT_BOUNDED : SESSION_CONTENT,
          variables: startDate ? { sessionId, startDate } : { sessionId },
        })
        .catch(() => {});
    },
    [client]
  );

  return prefetch;
};
